var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLanguage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12,3a9,9,0,1,0,9,9A9,9,0,0,0,12,3Zm6.92,8H17a13.46,13.46,0,0,0-1.19-4.88A7,7,0,0,1,18.92,11ZM11,11H9a9,9,0,0,1,2-5.47Zm0,2v5.47A9,9,0,0,1,9,13Zm2,0h2a9,9,0,0,1-2,5.47Zm0-2V5.53A9,9,0,0,1,15,11ZM8.22,6.12A13.46,13.46,0,0,0,7,11H5.08A7,7,0,0,1,8.22,6.12ZM5.08,13H7a13.46,13.46,0,0,0,1.19,4.88A7,7,0,0,1,5.08,13Zm10.7,4.88A13.46,13.46,0,0,0,17,13h2A7,7,0,0,1,15.78,17.88Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguage);
export default __webpack_public_path__ + "static/media/language.0c55cfcc5ff133d0d797cf69cc70b26c.svg";
export { ForwardRef as ReactComponent };